import { Accordion, Icon, Label } from 'semantic-ui-react';
import React from 'react';
import userService from '../services/userServices';
import { TextLink } from '../components/verizon/TextLink';
import { getNodeKey, nodeAccess, partition } from '../helpers/utils';
import userServices from '../services/userServices';
import { FILTER_KEYS, SOLUTION_TYPE } from '../helpers/const';
import { getFromStorage, setToStorage } from '../helpers/filter';

export const inventoryViewRequest = (locationId) => ({ type: 'INVENTORY_VIEW_REQUEST', locationId });
export const inventoryViewSuccess = (enterpriseName, ecpdId, nibId, networks, solutionType, updatedDate) => ({
    type: 'INVENTORY_VIEW_SUCCESS',
    enterpriseName,
    ecpdId,
    nibId,
    networks,
    solutionType,
    updatedDate
});
export const ibwaveViewSuccess = (buildings, ecpdId, updatedDate) => ({
    type: 'IBWAVE_VIEW_SUCCESS',
    buildings,
    ecpdId,
    updatedDate
});
export const ibwaveFpImageSuccess = (floorPlanImage) => ({
    type: 'IBWAVE_FLOOR_PLAN_IMAGE_SUCCESS',
    floorPlanImage
});
export const inventoryViewApiError = (message, form) => ({ type: 'INVENTORY_VIEW_API_ERROR', message, form });
export const ibwaveViewApiError = (message, form) => ({ type: 'IBWAVE_VIEW_API_ERROR', message, form });
export const ibwaveFpApiError = (message, form) => ({ type: 'IBWAVE_FLOOR_PLAN_IMAGE_ERROR', message, form });

export const downloadInventoryRequest = (file) => ({ type: 'DOWNLOAD_INVENTORY_REQUEST', file });
export const downloadInventorySuccess = (data) => ({ type: 'DOWNLOAD_INVENTORY_SUCCESS', data });
export const downloadInventoryApiError = (message, form) => ({ type: 'DOWNLOAD_INVENTORY_API_ERROR', message, form });

export const stopBlinkingMapComponent = (blink) => ({ type: 'STOP_BLINK_MAP_COMPONENT', blink });

export const offlineNodesSuccess = (data) => ({ type: 'FETCH_OFFLINE_NODE_SUCCESS', data });
export const offlineNodesRequest = (locationId) => ({ type: 'OFFLINE_NODE_REQUEST', data: { locationId } });
export const offlineNodeApiError = (message, form) => ({ type: 'OFFLINE_NODE_API_ERROR', message, form });

export const inBuildingViewRequest = () => ({ type: 'INBUILDING_VIEW_REQUEST' });
export const inBuildingViewSuccess = (data) => ({ type: 'INBUILDING_VIEW_SUCCESS', data });
export const inBuildingViewApiError = (message, form) => ({ type: 'INBUILDING_VIEW_API_ERROR', message, form });

export const networkKeys = {
    RADIO_NETWORK: 'RADIO_NETWORK',
    CORE_NETWORK: 'CORE_NETWORK'
};

export const networkTypeKey = {
    NSA_5G: 'NSA_5G',
    SA_5G: 'SA_5G',
    LTE: 'LTE'
};

const networkLookup = {
    [networkKeys.RADIO_NETWORK]: 'Radio network functions',
    [networkKeys.CORE_NETWORK]: 'Core network functions'
};

export const NodeKeys = {
    //Physical
    INDOOR_RADIO_UNIT: 'INDOOR_RADIO_UNIT',
    OUTDOOR_RADIO_4G: 'OUTDOOR_RADIO_4G',
    SMALL_CELL_RADIO_INDOOR: 'SMALL_CELL_RADIO_INDOOR',
    BASEBAND: 'BASEBAND',
    OUTDOOR_RADIO_5G: 'OUTDOOR_RADIO_5G',
    INDOOR_RADIO_5G: 'INDOOR_RADIO_5G',
    SMALL_CELL_RADIO_NODE_5G: 'SMALL_CELL_RADIO_NODE_5G',
    CORE_VIRTUALIZATION: 'CORE_VIRTUALIZATION',
    NETWORK_CONTROLLER: 'NETWORK_CONTROLLER',
    AMF: 'AMF',
    // Virtual
    CENTRALIZED_UNIT_5G: 'CENTRALIZED_UNIT_5G',
    UNIFIED_DATA_REPOSITORY: 'UNIFIED_DATA_REPOSITORY',
    PROVISIONING_GW: 'PROVISIONING_GW',
    LDP: 'LDP',
    PDU: 'PDU',
    // NDAC
    RADIO_ACCESS_4G: 'RADIO_ACCESS_4G',
    RADIO_ACCESS_5G: 'RADIO_ACCESS_5G',
    RRH: 'RRH',
    EDGE_CLOUD: 'EDGE_CLOUD',
    ENODEB: 'ENODEB',
    ROUTER: 'ROUTER'
};

const physical = {
    SITE_ROUTER: 'Site router',
    [NodeKeys.BASEBAND]: 'Baseband',
    IRU: 'IRU',
    [NodeKeys.SMALL_CELL_RADIO_INDOOR]: 'Indoor radio dot',
    [NodeKeys.OUTDOOR_RADIO_4G]: 'Outdoor radio 4G',
    [NodeKeys.INDOOR_RADIO_UNIT]: 'Indoor radio unit - IRU',
    [NodeKeys.PDU]: 'Power distrib. unit',
    [NodeKeys.CORE_VIRTUALIZATION]: 'Core virtualization HW',
    [NodeKeys.OUTDOOR_RADIO_5G]: 'Outdoor radio 5G',
    [NodeKeys.INDOOR_RADIO_5G]: 'Indoor radio 5G',
    [NodeKeys.SMALL_CELL_RADIO_NODE_5G]: 'Small cell 5G (DU/RU)',
    [NodeKeys.ROUTER]: 'Router',
    [NodeKeys.EDGE_CLOUD]: 'Edgecloud',
    [NodeKeys.RADIO_ACCESS_4G]: '4G_RADIO_ACCESS_4G',
    [NodeKeys.RADIO_ACCESS_5G]: 'RADIO_ACCESS_5G',
    [NodeKeys.RRH]: 'RRH',
    [NodeKeys.ENODEB]: 'ENODEB'
};
const virtual = {
    HSS_FE: 'HSS-FE',
    [NodeKeys.UNIFIED_DATA_REPOSITORY]: 'Unified data repository',
    [NodeKeys.PROVISIONING_GW]: 'Provisioning GW',
    MME: 'MME',
    PCRF: 'PCRF',
    SAE_GW: 'SAE GW',
    [NodeKeys.OUTDOOR_RADIO_4G]: 'Outdoor radio 4G',
    [NodeKeys.CENTRALIZED_UNIT_5G]: 'Centralized unit 5G',
    [NodeKeys.LDP]: 'Local domain proxy',
    [NodeKeys.NETWORK_CONTROLLER]: 'Network controller',
    [NodeKeys.AMF]: 'AMF'
};

// order to show core hardware (start at 1)
const coreOrder = {
    HSS_FE: 1,
    UNIFIED_DATA_REPOSITORY: 2,
    PROVISIONING_GW: 3,
    MME: 4,
    PCRF: 5,
    SAE_GW: 6,
    CORE_VIRTUALIZATION: 7,
    NETWORK_CONTROLLER: 1,
    SITE_ROUTER: 8,
    PDU: 9
};

// order to show radio hardware (start at 1)
const radioOrder = {
    BASEBAND: 1,
    INDOOR_RADIO_UNIT: 2,
    SMALL_CELL_RADIO_INDOOR: 3,
    OUTDOOR_RADIO_4G: 4,
    CENTRALIZED_UNIT_5G: 5,
    SMALL_CELL_RADIO_NODE_5G: 6,
    OUTDOOR_RADIO_5G: 7,
    SMALL_CELL_RADIO_CBRS: 8,
    OUTDOOR_RADIO_LTE: 9,
    OUTDOOR_RADIO_CBRS: 10,
    SMALL_CELL_5G_DURU: 11
};

const getColor = (val = '') => {
    if (val === 'ENABLED') return '#00AC3E';
    else if (val === 'DISABLED') return '#d52b1e';
};

const isBBChilds = (type) => {
    return type === NodeKeys.SMALL_CELL_RADIO_INDOOR || type === NodeKeys.INDOOR_RADIO_UNIT || type === NodeKeys.OUTDOOR_RADIO_4G;
};

const isCUChilds = (type) => {
    return type === NodeKeys.SMALL_CELL_RADIO_NODE_5G;
};

const renderLink = (node, nodeOnClick, solutionType) => {
    const key = getNodeKey(node, solutionType === SOLUTION_TYPE.NDAC);
    const keySplit = key.split('/');

    return {
        key,
        exclusive: false,
        defaultActiveIndex: [0],
        serialNumber: node.serialNumber,
        content: {
            className: 'leaf-content',
            content: (
                <TextLink onClick={nodeOnClick} value={key} className="tree-overflow-container">
                    {keySplit.length > 1 ? (
                        <div style={{ display: 'inline' }} title={keySplit[0] + '/' + keySplit[1]}>
                            <div className="statusDot" style={{ backgroundColor: getColor(node.operationalState) }}></div>
                            <span className="text-device-node">
                                {!!solutionType && solutionType === SOLUTION_TYPE.NDAC ? (
                                    <span className="node-text" style={{ display: 'inline' }}>
                                        {`${node.partCode ?? ''} ${node.partName ?? ''}`}
                                    </span>
                                ) : (
                                    <>
                                        <span className="tree-overflow-ellipsis node-text">{keySplit[0]}</span>
                                        <span className="node-text" style={{ display: 'inline' }}>
                                            /{keySplit[1]}
                                        </span>
                                    </>
                                )}
                                <span className="node-text" style={{ display: 'none' }}>
                                    {node?.serialNumber ? `/${node?.serialNumber}` : ''}
                                </span>
                            </span>
                        </div>
                    ) : (
                        <span className="text-device-node">{key}</span>
                    )}
                </TextLink>
            )
        }
    };
};

const persistAccordionState = (props, event, uniqueKey) => {
    // This is not a best practice, but there is no other way to deal with defaultActiveIndex for nested accordion.
    // The defaultActiveIndex works best with flat accordion structure as the index is based on the order of the panels.
    const { active } = props;
    const currentTarget = event.currentTarget;
    const expandedNodes = getExpandedNodes();

    if (!active && !(currentTarget.classList.contains('active') && expandedNodes.includes(uniqueKey))) {
        expandedNodes.push(uniqueKey);
    } else {
        const index = expandedNodes.indexOf(uniqueKey);

        if (index > -1) {
            expandedNodes.splice(index, 1);
            setTimeout(() => {
                document.querySelectorAll('.active.active').forEach((el) => {
                    if (el === currentTarget || el === currentTarget.nextSibling) {
                        el.classList.remove('active');
                    }
                });
            }, 10);
        }
    }
    setToStorage('', FILTER_KEYS.NETWORK_NAVIGATOR.INVENTORIES, expandedNodes);
};

const getExpandedNodes = () => {
    return getFromStorage('', FILTER_KEYS.NETWORK_NAVIGATOR.INVENTORIES) || [];
};

const buildAccordian = (key, name, count, content, className, isNetworkNode) => {
    let labelClassName = 'nodeLabel';
    let contentClassName = '';
    let titleClassName = className || '';
    let uniqueKey = key + name;

    if (isNetworkNode) {
        labelClassName = 'networkLabel';
        contentClassName = 'networkFunction';
        if (count <= 0) {
            labelClassName = labelClassName.concat(' no-panels');
            contentClassName = contentClassName.concat(' empty');
        }
    }

    if (getExpandedNodes().includes(uniqueKey)) {
        titleClassName = titleClassName.concat(' active');
        contentClassName = contentClassName.concat(' active');
    }

    return {
        key: uniqueKey,
        title: {
            content: <Label className={labelClassName} color={isNetworkNode ? 'black' : ''} content={`${name} (${count})`} />,
            icon: (
                <span className="tree-icons">
                    <Icon className="minus" />
                    <Icon className="minus to-be-plus" />
                </span>
            ),
            className: titleClassName,
            onClick: (event, props) => {
                persistAccordionState(props, event, uniqueKey);
            }
        },
        content: {
            content,
            className: contentClassName
        }
    };
};

/**
 * Level 4 - Node
 *
 * - Build nodes for Accordion
 * - Build object for east lookup
 * - count nodes
 */
const buildNode = ({ nodeList = [] }, nodeOnClick, solutionType) => {
    // Sort the nodeList before rendering links
    const sortedNodeList = nodeList.sort((a, b) => {
        if (solutionType === SOLUTION_TYPE.NDAC) {
            if (a.partCode < b.partCode) return -1;
            if (a.partCode > b.partCode) return 1;
            if (a.partName < b.partName) return -1;
            if (a.partName > b.partName) return 1;
        }
        if (a.nodeName < b.nodeName) return -1;
        if (a.nodeName > b.nodeName) return 1;
        return 0;
    });

    const nodes = sortedNodeList.map((node) => {
        return renderLink(node, nodeOnClick, solutionType);
    });
    const nodesLookup = {};
    nodeList.forEach((node) =>
        node.nodeType === 'CENTRALIZED_UNIT_5G'
            ? (nodesLookup[node.partName ? `${node.nodeName}/${node.partName}/${node.serialNumber}` : node.nodeName] = node)
            : (nodesLookup[
                  node.unitId
                      ? `${node.nodeName}/${node.unitId}/${node.serialNumber}` + (solutionType === SOLUTION_TYPE.NDAC ? `/${node.partName}` : ``)
                      : node.nodeName
              ] = node)
    );

    return {
        count: nodes.length,
        nodes,
        nodesLookup
    };
};

const updateChildAccordian = (i = 0, nodeList, nodeOnClick, nodeType, solutionType) => {
    const nodeResponse = buildNode({ nodeList }, nodeOnClick, solutionType);
    const accordian = buildAccordian(
        i,
        solutionType === 'NDAC' ? 'Radio head' : nodeType,
        nodeList?.length,
        <Accordion.Accordion className="leaf-child-accordion" exclusive={false} panels={nodeResponse.nodes} />,
        'child-accordion'
    );
    return {
        accordian,
        nodesLookup: nodeResponse.nodesLookup
    };
};

const getTypeNodeList = (parentNodes, type) => {
    let nodes = [];
    if (parentNodes) {
        parentNodes.forEach(({ nodeList }) => {
            if (nodeList) {
                nodeList.forEach((node) => {
                    if (node?.nodeType === type) {
                        nodes.push(node);
                    }
                });
            }
        });
    }
    return nodes;
};

const getChildNodes = (parentNodes, nodeName, type, unitId) => {
    const nodes = getTypeNodeList(parentNodes, type);
    let result = [];
    if (nodes?.length > 0) {
        result = nodes.filter((node) => {
            if (!!unitId) {
                const parentUnitIdentifier = unitId?.split('-')[1];
                const childUnitIdentifier = node?.unitId?.split('-')[1];
                return node.nodeName === nodeName && parentUnitIdentifier === childUnitIdentifier;
            } else {
                return node.nodeName === nodeName;
            }
        });
    }
    return result;
};

const getRadioDotNodes = (parentNodes, mappedRadios, type) => {
    const nodes = parentNodes.find((node) => node.nodeType === type)?.nodeList;
    let result = [];
    if (nodes?.length > 0) {
        const nodeNames = mappedRadios ? mappedRadios.map((mr) => mr.nodeName) : [];
        const unitIds = mappedRadios ? mappedRadios.map((mr) => mr.unitId) : [];
        result = nodes.filter((node) => nodeNames?.includes(node.nodeName) && unitIds?.includes(node.unitId));
    }
    return result;
};

const sortNodes = (nodes) => {
    // divide the array based on condition, With Unit Ids and Without Unit Ids
    const [wUnitIds, woUnitIds] = partition(nodes, (e) => !!e.unitId);

    let result = wUnitIds.sort((a, b) => {
        const partsA = a.unitId.split('-');
        const partsB = b.unitId.split('-');
        return partsA[partsA.length - 1] - partsB[partsB.length - 1];
    });

    // Merging arrays after shorting
    return [...result, ...woUnitIds];
};

export const getCounts = (networks) => {
    const updatedNetworks = removeAMF(networks);
    const counts = {
        TOTAL: 0,
        VIRTUAL: 0,
        PHYSICAL: 0,
        [networkKeys.RADIO_NETWORK]: 0,
        [networkKeys.CORE_NETWORK]: 0
    };
    updatedNetworks.forEach(({ networkType, parentNodes }) => {
        let parentNodesCount = 0;
        parentNodes.forEach(({ nodeList, count, nodeType: parentNodeType }) => {
            parentNodesCount += nodeList?.length || 0;

            if (!nodeList) {
                // Include disabled functions into counts
                if (parentNodeType === NodeKeys.LDP) {
                    parentNodesCount += count;
                    counts.VIRTUAL += count;
                } else if (parentNodeType === NodeKeys.UNIFIED_DATA_REPOSITORY) {
                    parentNodesCount += count;
                    counts.VIRTUAL += count;
                } else if (parentNodeType === NodeKeys.PROVISIONING_GW) {
                    parentNodesCount += count;
                    counts.VIRTUAL += count;
                } else if (parentNodeType === NodeKeys.CORE_VIRTUALIZATION) {
                    parentNodesCount += count;
                    counts.PHYSICAL += count;
                } else if (parentNodeType === NodeKeys.NETWORK_CONTROLLER) {
                    parentNodesCount += count;
                    counts.VIRTUAL += count;
                } else if (parentNodeType === NodeKeys.PDU) {
                    parentNodesCount += count;
                    counts.PHYSICAL += count;
                }
            }

            nodeList?.length > 0 &&
                nodeList.forEach((nodeListEle) => {
                    if (physical[nodeListEle?.nodeType]) {
                        counts.PHYSICAL += 1;
                    } else if (virtual[nodeListEle?.nodeType]) {
                        counts.VIRTUAL += 1;
                    }
                });
        });
        counts[networkType] = parentNodesCount;
    });

    counts.TOTAL = counts.RADIO_NETWORK + counts.CORE_NETWORK;
    return counts;
};

const buildBBNodes = (baseBandNodes, parentNodes, nodeOnClick) => {
    let accordians = [];
    let nodesLookup = {};
    let leadChildNodes = [];
    let panelNodes = [];
    const params = window.location.href;
    baseBandNodes.forEach((baseBandNode, i) => {
        let leadChildNodes = [];
        // let panelNodes = [];
        const nodesResponse = buildNode({ nodeList: [baseBandNode] }, nodeOnClick);
        nodesLookup = { ...nodesLookup, ...nodesResponse.nodesLookup };
        let active = false;

        // INDOOR_RADIO_UNIT (SMALL_CELL_RADIO_INDOOR)
        let indoorUnits = getChildNodes(parentNodes, baseBandNode.nodeName, NodeKeys.INDOOR_RADIO_UNIT);
        if (indoorUnits?.length > 0) {
            indoorUnits = sortNodes(indoorUnits);
            let leafAccordians = [];
            let leadParentNodes = [];
            indoorUnits.forEach((indoorUnit) => {
                let radioDotsUnits = getRadioDotNodes(parentNodes, indoorUnit.mappedRadios, NodeKeys.SMALL_CELL_RADIO_INDOOR);
                radioDotsUnits = sortNodes(radioDotsUnits);
                let radioDotsAccordians = [];
                const leafNodesResponse = buildNode({ nodeList: [indoorUnit] }, nodeOnClick);
                nodesLookup = { ...nodesLookup, ...leafNodesResponse.nodesLookup };
                if (radioDotsUnits?.length > 0) {
                    const radioDotsAccordian = updateChildAccordian(i, radioDotsUnits, nodeOnClick, physical[NodeKeys.SMALL_CELL_RADIO_INDOOR]);
                    radioDotsAccordians = [...radioDotsAccordians, radioDotsAccordian.accordian];
                    const radioParentNode = buildChildAccordian([], radioDotsAccordians, '', indoorUnit, nodeOnClick);
                    leadParentNodes = [...leadParentNodes, radioParentNode];
                    nodesLookup = { ...nodesLookup, ...radioDotsAccordian.nodesLookup };
                }
                radioDotsUnits.map((data) => {
                    if (
                        data.serialNumber == params?.split('inventory')[1]?.split('%')[2]?.slice(2) &&
                        data.unitId == params?.split('inventory')[1]?.split('%')[1]?.slice(2)
                    ) {
                        active = true;
                    }
                });
                active = false;
            });

            leafAccordians.push(
                <Accordion.Accordion className="child-accordion" defaultActiveIndex={[active ? 1 : 0]} exclusive={false} panels={leadParentNodes} />
            );

            const leafAccordian = buildAccordian(
                NodeKeys.INDOOR_RADIO_UNIT,
                physical[NodeKeys.INDOOR_RADIO_UNIT],
                indoorUnits.length,
                leafAccordians,
                'child-accordion'
            );

            leadChildNodes = [...leadChildNodes, leafAccordian];
        }

        // OUTDOOR_RADIO_4G
        const ourdoor4GUnits = getChildNodes(parentNodes, baseBandNode.nodeName, NodeKeys.OUTDOOR_RADIO_4G);
        if (ourdoor4GUnits?.length > 0) {
            const outdoor4GAccordian = updateChildAccordian(i, ourdoor4GUnits, nodeOnClick, physical[NodeKeys.OUTDOOR_RADIO_4G]);
            leadChildNodes = [...leadChildNodes, outdoor4GAccordian.accordian];
            //panelNodes = [...panelNodes, outdoor4GAccordian.accordian];
            nodesLookup = { ...nodesLookup, ...outdoor4GAccordian.nodesLookup };
        }

        // OUTDOOR_RADIO_5G
        const ourdoor5GUnits = getChildNodes(parentNodes, baseBandNode.nodeName, NodeKeys.OUTDOOR_RADIO_5G);
        if (ourdoor5GUnits?.length > 0) {
            const outdoor5GAccordian = updateChildAccordian(i, ourdoor5GUnits, nodeOnClick, physical[NodeKeys.OUTDOOR_RADIO_5G]);
            leadChildNodes = [...leadChildNodes, outdoor5GAccordian.accordian];
            //panelNodes = [...panelNodes, outdoor5GAccordian.accordian];
            nodesLookup = { ...nodesLookup, ...outdoor5GAccordian.nodesLookup };
        }

        // INDOOR_RADIO_5G
        const indoor5GRadioUnits = getChildNodes(parentNodes, baseBandNode.nodeName, NodeKeys.INDOOR_RADIO_5G);
        if (indoor5GRadioUnits?.length > 0) {
            const indoor5GRadio = updateChildAccordian(i, indoor5GRadioUnits, nodeOnClick, physical[NodeKeys.INDOOR_RADIO_5G]);
            leadChildNodes = [...leadChildNodes, indoor5GRadio.accordian];
            //const parentBBlinkNode = buildChildAccordian([], [indoor5GRadio.accordian], '', baseBandNode, nodeOnClick);
            //panelNodes.push(parentBBlinkNode);
            nodesLookup = { ...nodesLookup, ...indoor5GRadio.nodesLookup };
        }
        const parentBBlinkNode = buildChildAccordian([], leadChildNodes, '', baseBandNode, nodeOnClick);
        panelNodes.push(parentBBlinkNode);
    });

    accordians.push(
        <Accordion.Accordion
            defaultActiveIndex={[params?.split('inventory')[1]?.split('%')[2]?.slice(2) ? 1 : 0]}
            exclusive={false}
            panels={panelNodes}
        />
    );

    return {
        accordians,
        nodesLookup
    };
};

const buildNDACRRHNodes = (baseBandNodes, parentNodes, nodeOnClick) => {
    let accordians = [];
    let nodesLookup = {};
    let panelNodes = [];
    const params = window.location.href;
    baseBandNodes.forEach((baseBandNode, i) => {
        let leadChildNodes = [];
        const nodesResponse = buildNode({ nodeList: [baseBandNode] }, nodeOnClick, SOLUTION_TYPE.NDAC);
        nodesLookup = { ...nodesLookup, ...nodesResponse.nodesLookup };

        // RRH nodes
        const RRHNodes = getChildNodes(parentNodes, baseBandNode.nodeName, NodeKeys.RRH);
        if (RRHNodes?.length > 0) {
            const radioHeadAccordian = updateChildAccordian(i, RRHNodes, nodeOnClick, physical[NodeKeys.RRH], SOLUTION_TYPE.NDAC);
            leadChildNodes = [...leadChildNodes, radioHeadAccordian.accordian];
            nodesLookup = { ...nodesLookup, ...radioHeadAccordian.nodesLookup };
        }

        const parentNode = buildChildAccordian([], leadChildNodes, 'ndac', baseBandNode, nodeOnClick, SOLUTION_TYPE.NDAC);
        panelNodes.push(parentNode);
    });

    accordians.push(
        <Accordion.Accordion
            defaultActiveIndex={[params?.split('inventory')[1]?.split('%')[2]?.slice(2) ? 1 : 0]}
            exclusive={false}
            panels={panelNodes}
        />
    );

    return {
        accordians,
        nodesLookup
    };
};

const buildIbcCategory = (baseBandNodes, nodeOnClick) => {
    let accordians = [];
    let nodesLookup = {};
    let panelNodes = [];
    const params = window.location.href;
    baseBandNodes.forEach((baseBandNode, i) => {
        let leadChildNodes = [];
        const nodesResponse = buildNode({ nodeList: [baseBandNode] }, nodeOnClick);
        nodesLookup = { ...nodesLookup, ...nodesResponse.nodesLookup };
        const parentBBlinkNode = buildChildAccordian([], leadChildNodes, 'ibc', baseBandNode, nodeOnClick, SOLUTION_TYPE.IBC);
        panelNodes.push(parentBBlinkNode);
    });

    accordians.push(
        <Accordion.Accordion
            defaultActiveIndex={[params?.split('inventory')[1]?.split('%')[2]?.slice(2) ? 1 : 0]}
            exclusive={false}
            panels={panelNodes}
        />
    );

    return {
        accordians,
        nodesLookup
    };
};

const renderTreeIcons = (solutionType) => {
    if (solutionType === SOLUTION_TYPE.IBC) return null;
    return (
        <span className="tree-icons">
            <Icon className="minus" />
            <Icon className="minus to-be-plus" />
        </span>
    );
};

const buildChildAccordian = (parentContent1, childContent, className, node, nodeOnClick, solutionType) => {
    const key = getNodeKey(node, solutionType === SOLUTION_TYPE.NDAC);
    const ndacRadioNodeName = node?.displayName;
    const keySplit = key.split('/');
    let childAccordion = {
        key,
        exclusive: false,
        defaultActiveIndex: [0],
        serialNumber: node.serialNumber,
        title: {
            className: `leaf-content iru-child ${className}`,
            content: (
                <TextLink onClick={nodeOnClick} value={key} className="tree-overflow-container">
                    {keySplit.length > 1 ? (
                        <div style={{ display: 'inline' }} title={keySplit[0] + '/' + keySplit[1]}>
                            {renderTreeIcons(solutionType)}
                            <div className="statusDot" style={{ backgroundColor: getColor(node.operationalState) }}></div>
                            <span className="text-device-node">
                                {!!solutionType && solutionType === SOLUTION_TYPE.NDAC ? (
                                    <span className="tree-overflow-ellipsis iru-child node-text">{ndacRadioNodeName}</span>
                                ) : (
                                    <>
                                        <span className="tree-overflow-ellipsis iru-child node-text">{keySplit[0]}</span>
                                        <span className="node-text" style={{ display: 'inline' }}>
                                            /{keySplit[1]}
                                        </span>
                                    </>
                                )}
                                <span className="node-text" style={{ display: 'none' }}>
                                    {node.serialNumber}
                                </span>{' '}
                            </span>
                        </div>
                    ) : (
                        <div>
                            {renderTreeIcons(solutionType)}
                            <span className="text-device-node">{key}</span>
                        </div>
                    )}
                </TextLink>
            )
        }
    };
    if (!!childContent && childContent?.length) {
        childAccordion = {
            ...childAccordion,
            content: {
                content: <Accordion.Accordion exclusive={false} panels={childContent} />
            }
        };
    }
    return childAccordion;
};

const updateBaseChildAccordian = (i = 0, nodeList, nodeOnClick, nodeType) => {
    const nodeResponse = buildNode({ nodeList }, nodeOnClick);
    console.log('nodeList', nodeList);
    console.log('nodeType', nodeType);
    console.log('nodeResponse.nodes', nodeResponse.nodes);
    const accordian = buildAccordian(
        i,
        nodeType,
        nodeList?.length,
        <Accordion.Accordion className="leaf-child-accordion" exclusive={false} panels={nodeResponse.nodes} />,
        'child-accordion'
    );
    console.log('accordian', accordian);
    console.log('nodesLookup', nodeResponse.nodesLookup);
    return {
        accordian,
        nodesLookup: nodeResponse.nodesLookup
    };
};

const build4GNodes = (parentNodes, nodeOnClick) => {
    let accordians = [];
    let nodesLookup = {};
    let panels = [];
    let uniqueKey = 'parentsNodes=enb';
    let titleClassName = '';
    let contentClassName = '';

    if (getExpandedNodes().includes(uniqueKey)) {
        titleClassName = titleClassName.concat(' active');
        contentClassName = contentClassName.concat(' active');
    }
    // 1. 4G BaseBand Nodes
    const topNodes = parentNodes.filter((parentNode) => parentNode.nodeType === NodeKeys.BASEBAND);
    let baseBandCount = 0;
    topNodes.forEach(({ nodeList }) => {
        const enbNodes = nodeList?.filter((el) => nodeAccess(el.nodeName) === '4G');
        if (enbNodes?.length > 0) {
            baseBandCount += enbNodes.length;
            const enbDetails = buildBBNodes(enbNodes, parentNodes, nodeOnClick);
            if (!!enbDetails) {
                accordians = [...accordians, ...enbDetails.accordians];
                nodesLookup = { ...nodesLookup, ...enbDetails.nodesLookup };
            }
        }
    });
    panels.push(buildAccordian(NodeKeys.BASEBAND, physical[NodeKeys.BASEBAND], baseBandCount, accordians));
    const enbAccordian = {
        key: uniqueKey,
        title: {
            content: <Label className="nodeLabel" content={`4G radio access (${baseBandCount})`} />,
            icon: (
                <span className="tree-icons">
                    <Icon className="minus" />
                    <Icon className="minus to-be-plus" />
                </span>
            ),
            className: titleClassName,
            onClick: (event, props) => {
                persistAccordionState(props, event, uniqueKey);
            }
        },
        content: {
            content: <Accordion.Accordion defaultActiveIndex={[0]} exclusive={false} panels={panels} />,
            className: contentClassName
        }
    };
    return {
        count: baseBandCount,
        nodes: baseBandCount === 0 ? [] : [enbAccordian],
        nodesLookup: baseBandCount === 0 ? {} : nodesLookup
    };
};

const buildIBCNodes = (parentNodes, nodeOnClick) => {
    let nodesLookup = {};
    let panels = [];

    // 1. 4G BaseBand Nodes Category
    const topNodes = parentNodes.filter((parentNode) => parentNode.nodeType == NodeKeys.BASEBAND);
    let baseBandCount = topNodes?.[0]?.nodeList?.length || 0;
    const bbDetails = buildIbcCategory(topNodes?.[0]?.nodeList, nodeOnClick);
    if (!!bbDetails) {
        nodesLookup = { ...nodesLookup, ...bbDetails.nodesLookup };
        panels.push(buildAccordian(NodeKeys.BASEBAND, physical[NodeKeys.BASEBAND], topNodes?.[0]?.nodeList?.length, bbDetails?.accordians));
    }

    // 2. Indoor Radio Unit Nodes Category
    const rduNodes = parentNodes.filter((parentNode) => parentNode.nodeType == NodeKeys.INDOOR_RADIO_UNIT);
    baseBandCount = baseBandCount + rduNodes?.[0]?.nodeList?.length || 0;
    if (rduNodes?.[0]?.nodeList?.length > 0) {
        const rduDetails = buildIbcCategory(rduNodes?.[0]?.nodeList, nodeOnClick);
        nodesLookup = { ...nodesLookup, ...rduDetails.nodesLookup };
        panels.push(
            buildAccordian(NodeKeys.INDOOR_RADIO_UNIT, physical[NodeKeys.INDOOR_RADIO_UNIT], rduNodes?.[0]?.nodeList?.length, rduDetails?.accordians)
        );
    }

    // 3. Indoor Radio Dots Nodes Category
    const rdNodes = parentNodes.filter((parentNode) => parentNode.nodeType == NodeKeys.SMALL_CELL_RADIO_INDOOR);
    baseBandCount = baseBandCount + rdNodes?.[0]?.nodeList?.length || 0;
    if (rdNodes?.[0]?.nodeList?.length > 0) {
        const rdDetails = buildIbcCategory(rdNodes?.[0]?.nodeList, nodeOnClick);
        nodesLookup = { ...nodesLookup, ...rdDetails.nodesLookup };
        panels.push(
            buildAccordian(
                NodeKeys.SMALL_CELL_RADIO_INDOOR,
                physical[NodeKeys.SMALL_CELL_RADIO_INDOOR],
                rdNodes?.[0]?.nodeList?.length,
                rdDetails?.accordians
            )
        );
    }

    return {
        count: baseBandCount,
        nodes: baseBandCount === 0 ? [] : panels,
        nodesLookup: baseBandCount === 0 ? {} : nodesLookup
    };
};

const build5GNodes = (parentNodes, nodeOnClick) => {
    let accordians = [];
    let nodesLookup = {};
    let panels = [];

    // 1. 5G BaseBand Nodes
    const topNodes = parentNodes.filter((parentNode) => parentNode.nodeType == NodeKeys.BASEBAND);
    let topNodesCount = 0;
    topNodes.forEach(({ nodeList }) => {
        const gnbNodes = nodeList?.filter((el) => nodeAccess(el.nodeName) === '5G');
        if (gnbNodes?.length > 0) {
            topNodesCount += gnbNodes.length;
            const gnbDetails = buildBBNodes(gnbNodes, parentNodes, nodeOnClick);
            if (!!gnbDetails) {
                accordians = [...accordians, ...gnbDetails.accordians];
                nodesLookup = { ...nodesLookup, ...gnbDetails.nodesLookup };
            }
        }
    });
    if (accordians.length > 0) {
        panels.push(buildAccordian(NodeKeys.BASEBAND, physical[NodeKeys.BASEBAND], topNodesCount, accordians));
    }

    // 2. CU 5G Nodes
    const cuNodes = buildCUNodes(parentNodes, nodeOnClick);
    if (!!cuNodes) {
        nodesLookup = { ...nodesLookup, ...cuNodes.nodesLookup };
        panels.push(...cuNodes.nodes);
        topNodesCount += cuNodes.count;
    }

    // 3. Outdoor 5G nodes
    const outdoor5GNode = parentNodes.find((parentNode) => parentNode.nodeType == NodeKeys.OUTDOOR_RADIO_5G);
    if (outdoor5GNode?.nodeList?.length > 0) {
        const outdoor5GNodelist = outdoor5GNode.nodeList.filter((el) => nodeAccess(el.nodeName) === '5G');
        if (outdoor5GNodelist.length > 0) {
            topNodesCount += outdoor5GNodelist.length;
            const outdoor5GNodes = buildNode({ nodeList: outdoor5GNodelist }, nodeOnClick);
            nodesLookup = { ...nodesLookup, ...outdoor5GNodes.nodesLookup };

            panels.push(
                buildAccordian(
                    NodeKeys.OUTDOOR_RADIO_5G,
                    physical[NodeKeys.OUTDOOR_RADIO_5G],
                    outdoor5GNodelist.length,
                    <Accordion.Accordion defaultActiveIndex={[0]} exclusive={false} panels={outdoor5GNodes.nodes} />
                )
            );
        }
    }

    if (topNodesCount > 0 || outdoor5GNode?.disabled) {
        return {
            nodes: [
                buildAccordian(
                    '5GNB',
                    '5G radio access',
                    topNodesCount,
                    <Accordion.Accordion defaultActiveIndex={[0]} exclusive={false} panels={panels} />,
                    outdoor5GNode?.disabled ? 'disabled' : ''
                )
            ],
            nodesLookup
        };
    } else {
        return {
            nodes: [],
            nodesLookup
        };
    }
};

const buildNDAC4GNodes = (parentNodes, nodeOnClick) => {
    let accordians = [];
    let nodesLookup = {};
    let nodes = [];

    // 4G BaseBand Nodes
    const topNodes = parentNodes.filter((parentNode) => parentNode.nodeType == NodeKeys.RADIO_ACCESS_4G);
    let topNodesCount = 0;
    if (topNodes?.length > 0) {
        topNodes.forEach(({ nodeList }) => {
            const nodeList4G = nodeList?.filter((el) => el.nodeType === NodeKeys.RADIO_ACCESS_4G);
            if (nodeList4G?.length > 0) {
                topNodesCount += nodeList4G.length;
                const nodeDetails = buildNDACRRHNodes(nodeList4G, parentNodes, nodeOnClick);
                if (!!nodeDetails) {
                    accordians = [...accordians, ...nodeDetails.accordians];
                    nodesLookup = { ...nodesLookup, ...nodeDetails.nodesLookup };
                }
            }
        });
        if (accordians.length > 0) {
            nodes = [buildAccordian(NodeKeys.RADIO_ACCESS_4G, '4G radio access', topNodesCount, accordians)];
        }
    }
    return {
        nodes,
        nodesLookup
    };
};

const buildNDAC5GNodes = (parentNodes, nodeOnClick) => {
    let accordians = [];
    let nodesLookup = {};
    let nodes = [];

    // 5G BaseBand Nodes
    const topNodes = parentNodes.filter((parentNode) => parentNode.nodeType == NodeKeys.RADIO_ACCESS_5G);
    let topNodesCount = 0;
    if (topNodes?.length > 0) {
        topNodes.forEach(({ nodeList }) => {
            const nodeList5G = nodeList?.filter((el) => el.nodeType === NodeKeys.RADIO_ACCESS_5G);
            if (nodeList5G?.length > 0) {
                topNodesCount += nodeList5G.length;
                const nodeDetails = buildNDACRRHNodes(nodeList5G, parentNodes, nodeOnClick);
                if (!!nodeDetails) {
                    accordians = [...accordians, ...nodeDetails.accordians];
                    nodesLookup = { ...nodesLookup, ...nodeDetails.nodesLookup };
                }
            }
        });
        if (accordians.length > 0) {
            nodes = [buildAccordian(NodeKeys.RADIO_ACCESS_5G, '5G radio access', topNodesCount, accordians)];
        }
    }

    return {
        nodes,
        nodesLookup
    };
};

const build4G5GNodes = (parentNodes, nodeOnClick) => {
    let accordians = [];
    let nodesLookup = {};
    let panels = [];

    // 1. 4G5G BaseBand Nodes
    const topNodes = parentNodes.filter((parentNode) => parentNode.nodeType == NodeKeys.BASEBAND);
    let topNodesCount = 0;
    topNodes.forEach(({ nodeList }) => {
        const gnbNodes = nodeList?.filter((el) => nodeAccess(el.nodeName) === '4G5G');
        if (gnbNodes?.length > 0) {
            topNodesCount += gnbNodes.length;
            const gnbDetails = buildBBNodes(gnbNodes, parentNodes, nodeOnClick);
            if (!!gnbDetails) {
                accordians = [...accordians, ...gnbDetails.accordians];
                nodesLookup = { ...nodesLookup, ...gnbDetails.nodesLookup };
            }
        }
    });
    if (accordians.length > 0) {
        panels.push(buildAccordian(NodeKeys.BASEBAND, physical[NodeKeys.BASEBAND], topNodesCount, accordians));
    }

    // 2. CU 4G5G Nodes
    const topCUNodes = parentNodes.filter((parentNode) => parentNode.nodeType == NodeKeys.CENTRALIZED_UNIT_5G);
    topCUNodes.forEach(({ nodeList }) => {
        const combinedNodes = nodeList?.filter((el) => nodeAccess(el.nodeName) === '4G5G');
        if (combinedNodes?.length > 0) {
            topNodesCount += combinedNodes.length;
            const combinedDetails = buildCUNodes(parentNodes, nodeOnClick);
            if (!!combinedDetails) {
                accordians = [...accordians, ...combinedDetails.accordians];
                nodesLookup = { ...nodesLookup, ...combinedDetails.nodesLookup };
            }
        }
    });

    // 3. Outdoor 4G5G nodes
    const outdoor4G5GNode = parentNodes.find((parentNode) => parentNode.nodeType == NodeKeys.OUTDOOR_RADIO_5G);
    if (outdoor4G5GNode?.nodeList?.length > 0) {
        const outdoor4G5GNodelist = outdoor4G5GNode.nodeList.filter((el) => nodeAccess(el.nodeName) === '4G5G');
        if (outdoor4G5GNodelist.length > 0) {
            topNodesCount += outdoor4G5GNodelist.length;
            const outdoor5GNodes = buildNode({ nodeList: outdoor4G5GNodelist }, nodeOnClick);
            nodesLookup = { ...nodesLookup, ...outdoor5GNodes.nodesLookup };

            panels.push(
                buildAccordian(
                    NodeKeys.OUTDOOR_RADIO_5G,
                    physical[NodeKeys.OUTDOOR_RADIO_5G],
                    outdoor4G5GNodelist.length,
                    <Accordion.Accordion defaultActiveIndex={[0]} exclusive={false} panels={outdoor5GNodes.nodes} />
                )
            );
        }
    }

    if (topNodesCount > 0 || outdoor4G5GNode?.disabled) {
        return {
            nodes: [
                buildAccordian(
                    '5GNB',
                    '4G & 5G Mixed-mode radio access',
                    topNodesCount,
                    <Accordion.Accordion defaultActiveIndex={[0]} exclusive={false} panels={panels} />,
                    outdoor4G5GNode?.disabled ? 'disabled' : ''
                )
            ],
            nodesLookup
        };
    } else {
        return {
            nodes: [],
            nodesLookup
        };
    }
};

const buildCUNodes = (parentNodes, nodeOnClick) => {
    let accordions = [];
    let nodesLookup = {};
    let cuAccordion;
    const topNodes = parentNodes.filter((parentNode) => parentNode.nodeType === NodeKeys.CENTRALIZED_UNIT_5G);
    const cuCount = topNodes?.[0]?.nodeList?.length || 0;
    let panelNodes = [];
    topNodes.forEach(({ nodeList: cuNodes }) => {
        (cuNodes || []).forEach((cuNode, i) => {
            let leadChildNodes = [];
            const nodesResponse = buildNode({ nodeList: [cuNode] }, nodeOnClick);
            nodesLookup = { ...nodesLookup, ...nodesResponse.nodesLookup };
            let active = false;
            // SMALL_CELL_RADIO_NODE_5G
            let smallCell5GUnits = getChildNodes(parentNodes, cuNode.nodeName, NodeKeys.SMALL_CELL_RADIO_NODE_5G);
            if (smallCell5GUnits?.length > 0) {
                smallCell5GUnits = sortNodes(smallCell5GUnits);
                const smallCellAccordian = updateChildAccordian(i, smallCell5GUnits, nodeOnClick, physical[NodeKeys.SMALL_CELL_RADIO_NODE_5G]);
                leadChildNodes = [...leadChildNodes, smallCellAccordian.accordian];
                nodesLookup = { ...nodesLookup, ...smallCellAccordian.nodesLookup };
            }
            const parentCUNode = buildChildAccordian([], leadChildNodes, '', cuNode, nodeOnClick);
            panelNodes.push(parentCUNode);
        });
        accordions.push(<Accordion.Accordion defaultActiveIndex={[0]} exclusive={false} panels={panelNodes} />);
    });

    if (cuCount > 0) {
        cuAccordion = buildAccordian(NodeKeys.CENTRALIZED_UNIT_5G, virtual[NodeKeys.CENTRALIZED_UNIT_5G], cuCount, accordions);
    }

    return {
        count: cuCount,
        nodes: cuAccordion ? [cuAccordion] : [],
        nodesLookup
    };
};

/**
 * Level 3 - Parent Node
 * - Build nodes for Accordion
 * - Build object for east lookup
 * - count nodes
 */
const buildParentNode = ({ parentNodes = [] }, nodeOnClick, networkType, ldps, solutionType) => {
    let nodesLookup = {};
    let nodes = [];
    const count = {
        PHYSICAL: 0,
        VIRTUAL: !!ldps && ldps >= 2 ? ldps : 0
    };

    if (networkType === networkKeys.RADIO_NETWORK) {
        if (solutionType === SOLUTION_TYPE.IBC) {
            // 4G Radio Access
            let nestedNodes = buildIBCNodes(parentNodes, nodeOnClick);
            nodes = [...nestedNodes.nodes];
            nodesLookup = { ...nestedNodes.nodesLookup };
            // Update the counts
            count.PHYSICAL += nestedNodes.count;
        } else if (solutionType === SOLUTION_TYPE.NDAC) {
            // 4G Radio Access
            let nestedNodes = buildNDAC4GNodes(parentNodes, nodeOnClick);
            nodes = [...nestedNodes.nodes];
            nodesLookup = { ...nestedNodes.nodesLookup };
            // Update the counts
            count.PHYSICAL += nestedNodes.count;

            // 5G Radio Access
            nestedNodes = buildNDAC5GNodes(parentNodes, nodeOnClick);
            nodes = [...nodes, ...nestedNodes.nodes];
            nodesLookup = { ...nodesLookup, ...nestedNodes.nodesLookup };
        } else {
            // 4G Radio Access
            let nestedNodes = build4GNodes(parentNodes, nodeOnClick);
            nodes = [...nestedNodes.nodes];
            nodesLookup = { ...nestedNodes.nodesLookup };
            // Update the counts
            count.PHYSICAL += nestedNodes.count;

            // 5G Radio Access
            nestedNodes = build5GNodes(parentNodes, nodeOnClick);
            nodes = [...nodes, ...nestedNodes.nodes];
            nodesLookup = { ...nodesLookup, ...nestedNodes.nodesLookup };

            // 4G & 5G Mixed-Mode Radio Access
            nestedNodes = build4G5GNodes(parentNodes, nodeOnClick);
            nodes = [...nodes, ...nestedNodes.nodes];
            nodesLookup = { ...nodesLookup, ...nestedNodes.nodesLookup };
        }
    }

    const regularNodes = parentNodes
        .filter(
            (parentNode) =>
                // BB Nodes
                parentNode.nodeType !== NodeKeys.BASEBAND &&
                !isBBChilds(parentNode.nodeType) &&
                // CU 5G Nodes
                parentNode.nodeType !== NodeKeys.CENTRALIZED_UNIT_5G &&
                !isCUChilds(parentNode.nodeType) &&
                // OUTDOOR_RADIO_5G
                parentNode.nodeType !== NodeKeys.OUTDOOR_RADIO_5G &&
                parentNode.nodeType !== NodeKeys.INDOOR_RADIO_5G &&
                // NDAC
                parentNode.nodeType !== NodeKeys.RADIO_ACCESS_4G &&
                parentNode.nodeType !== NodeKeys.RADIO_ACCESS_5G &&
                parentNode.nodeType !== NodeKeys.RRH
        )
        .map((parentNode, i) => {
            let name = parentNode.nodeType;

            if (parentNode.disabled) {
                if (physical[parentNode.nodeType]) {
                    name = physical[parentNode.nodeType];
                    count.PHYSICAL += parentNode.count;
                } else if (virtual[parentNode.nodeType]) {
                    name = virtual[parentNode.nodeType];
                    count.VIRTUAL += parentNode.count;
                }

                return {
                    key: `parentsNodes=${name}-${i}`,
                    title: {
                        content: (
                            // `${name} (${parentNode.count})`,
                            <Label className="nodeLabel" content={`${name} (${parentNode.count})`} />
                        ),

                        icon: (
                            <span className="tree-icons">
                                <Icon className="minus" />
                                {/* <Icon className="minus to-be-plus" /> */}
                            </span>
                        ),
                        // icon: <Icon className="minus-small" />,

                        className: 'disabled',
                        onClick: (event) => {
                            event.preventDefault();
                            return false;
                        }
                    }
                };
            }
            const nodesResponse = buildNode(parentNode, nodeOnClick);

            nodesLookup = { ...nodesLookup, ...nodesResponse.nodesLookup };

            if (physical[parentNode.nodeType]) {
                name = physical[parentNode.nodeType];
                count.PHYSICAL += nodesResponse.count;
            } else if (virtual[parentNode.nodeType]) {
                name = virtual[parentNode.nodeType];
                count.VIRTUAL += nodesResponse.count;
            }

            return buildAccordian(
                `${name}-${i}`,
                name,
                nodesResponse.count,
                <Accordion.Accordion defaultActiveIndex={[0]} exclusive={false} panels={nodesResponse.nodes} />
            );
        });
    nodes = [...nodes, ...regularNodes];

    return {
        count,
        nodes,
        nodesLookup
    };
};

/**
 * Level 2 - Network Node
 * - Build nodes for Accordion
 * - Build object for east lookup
 * - count nodes
 */
const buildNetworks = (networkArr = [], nodeOnClick, ldps, solutionType) => {
    let nodesLookup = {};

    let defaultNodesIndex = {};

    const counts = getCounts(networkArr);
    const networks = networkArr.map((network, i) => {
        const nodesResponse = buildParentNode(network, nodeOnClick, network.networkType, ldps, solutionType);
        nodesLookup = { ...nodesLookup, ...nodesResponse.nodesLookup };
        const disabled = false;
        const defaultIndex = network?.parentNodes?.findIndex((el) => el?.nodeList?.length > 0) || 0;
        defaultNodesIndex[network.networkType] = Object.keys(nodesLookup).length;

        return buildAccordian(
            `network-${network.networkType}-${i}`,
            networkLookup[network.networkType],
            counts[network.networkType],
            <Accordion.Accordion defaultActiveIndex={[defaultIndex]} exclusive={false} panels={nodesResponse.nodes} />,
            disabled ? 'disabled' : '',
            true
        );
    });

    let defaultNetworkActiveIndex = 0;
    if (defaultNodesIndex[networkKeys.RADIO_NETWORK] > 0) {
        defaultNetworkActiveIndex = 1;
    }

    return {
        counts,
        networks,
        nodesLookup,
        defaultActiveIndex: defaultNetworkActiveIndex
    };
};

/**
 * These are not able to be grabbed from enum
 *
 */
const disableCoreRadio = [
    {
        nodeType: 'UNIFIED_DATA_REPOSITORY',
        disabled: true,
        count: 2
    },
    {
        nodeType: 'PROVISIONING_GW',
        disabled: true,
        count: 2
    },
    {
        nodeType: 'CORE_VIRTUALIZATION',
        disabled: true,
        count: 2
    },
    {
        nodeType: 'PDU',
        disabled: true,
        count: 1
    }
];

const disableRadio = [
    {
        nodeType: 'OUTDOOR_RADIO_5G',
        disabled: true,
        count: 1
    },
    {
        nodeType: 'SMALL_CELL_RADIO_NODE_5G',
        disabled: true,
        count: 1
    },
    {
        nodeType: 'CENTRALIZED_UNIT_5G',
        disabled: true,
        count: 1
    }
];

const addDisabledData = (networks = [], is5GAllowed, isDisabledSmall, isDisabledCentralized, isDisaledOutDoor, ldps, solutionType) => {
    return networks.map((network) => {
        const newNetwork = network;

        if (!is5GAllowed && newNetwork.networkType === networkKeys.RADIO_NETWORK) {
            const posSmallCell = newNetwork.parentNodes.findIndex((x) => x === 'SMALL_CELL_RADIO_5G');
            const posCentralizedUnit = newNetwork.parentNodes.findIndex((x) => x === 'CENTRALIZED_UNIT_5G');
            const posOutDoorRadio = newNetwork.parentNodes.findIndex((x) => x === 'OUTDOOR_RADIO_5G');
            posSmallCell >= 0 && newNetwork.parentNodes.splice(posSmallCell, 1);
            posCentralizedUnit >= 0 && newNetwork.parentNodes.splice(posCentralizedUnit, 1);
            posOutDoorRadio >= 0 && newNetwork.parentNodes.splice(posOutDoorRadio, 1);

            // Remove Mixed RAN 4G5G nodes
            newNetwork.parentNodes = newNetwork.parentNodes.map((parentNode) =>
                parentNode?.nodeList?.length > 0
                    ? { ...parentNode, nodeList: parentNode.nodeList.filter((el) => !el.nodeName?.includes('5G')) }
                    : parentNode
            );
        }

        if (newNetwork.networkType === networkKeys.CORE_NETWORK && (solutionType === SOLUTION_TYPE.EP5G || solutionType === SOLUTION_TYPE.NHN_PWN)) {
            newNetwork.parentNodes = newNetwork.parentNodes.concat([
                {
                    nodeType: NodeKeys.NETWORK_CONTROLLER,
                    disabled: true,
                    count: 2
                }
            ]);
        } else {
            if (newNetwork.networkType === networkKeys.CORE_NETWORK && solutionType !== SOLUTION_TYPE.NHN_PWN) {
                if (!!ldps && ldps >= 2) {
                    // if (!!ldps && ldps >= 12) {
                    newNetwork.parentNodes = newNetwork.parentNodes.concat([
                        ...disableCoreRadio,
                        {
                            nodeType: NodeKeys.LDP,
                            disabled: true,
                            count: ldps
                        }
                    ]);
                } else {
                    newNetwork.parentNodes = newNetwork.parentNodes.concat(disableCoreRadio);
                }
            }
        }

        // Incase to see grayout option
        if (!is5GAllowed && newNetwork.networkType === networkKeys.RADIO_NETWORK && solutionType !== SOLUTION_TYPE.NHN_PWN) {
            let disabledBasedOnData = disableRadio;
            const posOutDoor = disabledBasedOnData.findIndex((x) => x.nodeType === 'OUTDOOR_RADIO_5G');
            isDisaledOutDoor && posOutDoor >= 0 && disabledBasedOnData.splice(posOutDoor, 1);
            const posSmallCell = disabledBasedOnData.findIndex((x) => x.nodeType === 'SMALL_CELL_RADIO_NODE_5G');
            isDisabledSmall && posSmallCell >= 0 && disabledBasedOnData.splice(posSmallCell, 1);
            const posCentralizedUnit = disabledBasedOnData.findIndex((x) => x.nodeType === 'CENTRALIZED_UNIT_5G');
            isDisabledCentralized && posCentralizedUnit >= 0 && disabledBasedOnData.splice(posCentralizedUnit, 1);

            newNetwork.parentNodes = newNetwork.parentNodes.concat(disabledBasedOnData);
        }

        return newNetwork;
    });
};

const sortNetworks = (networks = []) => {
    networks.forEach((network) => {
        const order = network.networkType === networkKeys.CORE_NETWORK ? coreOrder : radioOrder;
        const orderNotFound = network.networkType === networkKeys.CORE_NETWORK ? coreOrder : radioOrder;

        network.parentNodes.sort((node1, node2) => {
            return (order[node1.nodeType] || orderNotFound) - (order[node2.nodeType] || orderNotFound);
        });
    });
};

const findFirstKey = (networks = [], solutionType) => {
    let key;
    // find first
    if (networks.length > 0) {
        const canRadioNetworkVisible = networks[1]?.parentNodes?.find((el) => el?.nodeList?.length > 0 && el?.nodeType === NodeKeys.BASEBAND);
        return !!canRadioNetworkVisible
            ? getNodeKey(
                  networks[1]?.parentNodes?.find((el) => el?.nodeList?.length > 0 && el?.nodeType === NodeKeys.BASEBAND)?.nodeList[0],
                  solutionType === SOLUTION_TYPE.NDAC
              )
            : getNodeKey(networks[0]?.parentNodes?.find((el) => el?.nodeList?.length > 0)?.nodeList[0], solutionType === SOLUTION_TYPE.NDAC);
    }

    return key;
};

const mergeNodeList = (bands = []) => {
    let newArray = [];
    for (let num = 0; num < bands.length; num++) {
        newArray = newArray.concat(bands[num].nodeList);
    }
    return newArray;
};

const multipleArrayNodes = (multiArray = [], val = '') => {
    const mergeBaseBand = multiArray.length > 0 && mergeNodeList(multiArray);
    return { nodeType: val, nodeList: mergeBaseBand };
};

export const setDisabledNodes = (networks, ldps, isManageAllowed5G, solutionType) => {
    const typeOfRadioBands = [
        'BASEBAND',
        'SMALL_CELL_RADIO_INDOOR',
        'INDOOR_RADIO_UNIT',
        'OUTDOOR_RADIO_4G',
        'OUTDOOR_RADIO_5G',
        'INDOOR_RADIO_5G',
        'SMALL_CELL_RADIO_NODE_5G',
        'CENTRALIZED_UNIT_5G',
        'RADIO_ACCESS_4G',
        'RADIO_ACCESS_5G',
        NodeKeys.RRH,
        NodeKeys.EDGE_CLOUD,
        NodeKeys.ENODEB,
        NodeKeys.ROUTER,
        'CELLS'
    ];
    const newNetworksArr = [];
    const pos = networks.findIndex((x) => x.networkType === networkKeys.RADIO_NETWORK);

    //logic for merging multiple same network

    if (pos >= 0) {
        typeOfRadioBands.map((e) => {
            const nodeBaseband = networks[pos].parentNodes.filter((x) => x.nodeType === e);
            if (nodeBaseband.length > 0) {
                const base = multipleArrayNodes(nodeBaseband, e);
                newNetworksArr.push({ nodeType: e, nodeList: base.nodeList });
            }
        });
        const newNetworks = { networkType: networkKeys.RADIO_NETWORK, parentNodes: newNetworksArr };
        networks.splice(pos, 1);
        networks.push(newNetworks);
    }

    // Remove 5G data if needed

    let isDisabledSmallCell = true;
    let isDisabledCentralizedUnit = true;
    let isDisaledOutDoorRadio = true;

    if (!isManageAllowed5G && pos >= 0) {
        if (solutionType === SOLUTION_TYPE.NDAC) {
            const posRadio5G = networks[pos].parentNodes.findIndex((x) => x.nodeType === 'RADIO_ACCESS_5G');
            if (posRadio5G >= 0) {
                networks[pos].parentNodes.splice(posRadio5G, 1);
            }

            const posRRH = networks[pos].parentNodes.findIndex((x) => x.nodeType === 'RRH');
            if (posRRH >= 0) {
                const RRHObj = networks[pos].parentNodes.find((x) => x.nodeType === 'RRH');
                RRHObj.nodeList = RRHObj?.nodeList.filter((node) => node.radioAccessTechnology !== '5G');
            }
        } else {
            const posSmallCell = networks[pos].parentNodes.findIndex((x) => x.nodeType === 'SMALL_CELL_RADIO_NODE_5G');
            if (posSmallCell >= 0) {
                networks[pos].parentNodes.splice(posSmallCell, 1);
                isDisabledSmallCell = false;
            }
            const posCentralizedUnit = networks[pos].parentNodes.findIndex((x) => x.nodeType === 'CENTRALIZED_UNIT_5G');

            if (posCentralizedUnit >= 0) {
                networks[pos].parentNodes.splice(posCentralizedUnit, 1);
                isDisabledCentralizedUnit = false;
            }
            const posOutDoorRadio = networks[pos].parentNodes.findIndex((x) => x.nodeType === 'OUTDOOR_RADIO_5G');
            if (posOutDoorRadio >= 0) {
                networks[pos].parentNodes.splice(posOutDoorRadio, 1);
                isDisaledOutDoorRadio = false;
            }
        }
    }

    // there are some elements we cant show so add as disabled
    if (solutionType !== SOLUTION_TYPE.NDAC && solutionType !== SOLUTION_TYPE.IBC) {
        addDisabledData(networks, isManageAllowed5G, isDisabledSmallCell, isDisabledCentralizedUnit, isDisaledOutDoorRadio, ldps, solutionType);
    }
};

const removeAMF = (networks) =>
    networks.map((network) => {
        if (!network.parentNodes) {
            network.parentNodes = [];
        }
        if (network?.networkType === networkKeys.CORE_NETWORK) {
            return {
                networkType: network?.networkType,
                parentNodes: network?.parentNodes?.filter((parentNode) => parentNode?.nodeType !== NodeKeys.AMF)
            };
        }
        return network;
    });

const updateIBCNetworks = (updatedNetworks) => {
    return updatedNetworks.map((network) => {
        return {
            ...network,
            parentNodes: network?.parentNodes?.map((parentNode) => {
                return {
                    ...parentNode,
                    nodeList: parentNode?.nodeList?.map((node) => {
                        // return { ...node, nodeName: node?.partId, operationalState: 'DISABLED', unitId: node?.partId };
                        return { ...node, nodeName: node?.partId };
                    })
                };
            })
        };
    });
};

/**
 * Level 1 - Location Node
 * - Build nodes for Accordion
 * - Build object for east lookup
 * - count nodes
 */
export const processInventoryForUi = ({ nibId, ldps, networks = [] }, nodeOnClick, solutionType, isManageAllowed5G, defaultActiveIndex) => {
    let updatedNetworks = fixCorruptedData(networks);
    updatedNetworks = removeAMF(networks);

    if (solutionType === SOLUTION_TYPE.IBC) {
        updatedNetworks = updateIBCNetworks(updatedNetworks, ldps, isManageAllowed5G);
    }

    setDisabledNodes(updatedNetworks, ldps, isManageAllowed5G, solutionType);
    // sort the networks based on provided list
    sortNetworks(updatedNetworks);

    const onTitleClick = (event, props) => {
        // const { index } = props;
        // activeIndex = index; FIXME: why it was added without initialization?
    };

    const nodesResponse = buildNetworks(updatedNetworks, nodeOnClick, ldps, solutionType);
    const defaultNetworkActiveIndex = defaultActiveIndex || nodesResponse?.defaultActiveIndex || 0;
    const { counts, nodesLookup } = nodesResponse;

    const selectedNodeId = findFirstKey(updatedNetworks, solutionType);

    const locations = {
        key: `location`,
        title: {
            content: `${nibId} (${counts.TOTAL})`,
            icon: (
                <span className="tree-icons">
                    <Icon className="minus" />
                    <Icon className="minus to-be-plus" />
                </span>
            )
        },
        content: {
            content: (
                <Accordion.Accordion
                    defaultActiveIndex={[defaultNetworkActiveIndex]}
                    exclusive={false}
                    panels={nodesResponse.networks}
                    onTitleClick={onTitleClick}
                />
            )
        }
    };

    return {
        counts,
        locations: [locations.content],
        nodesLookup,
        selectedNodeId
    };
};

/**
 * Fixes corrupted data in the networks array.
 * Ensures that each network has a parentNodes array.
 * Ensures that each parentNode has a nodeList array.
 *
 * @param {Array} networks - The array of network objects to be fixed.
 * @returns {Array} - The fixed array of network objects.
 */
export const fixCorruptedData = (networks) => {
    if (!Array.isArray(networks)) {
        return [];
    }

    return networks.map((network) => {
        if (typeof network !== 'object' || network === null) {
            return {};
        }

        if (!Array.isArray(network.parentNodes)) {
            network.parentNodes = [];
        }

        network.parentNodes = network.parentNodes.map((parentNode) => {
            if (typeof parentNode !== 'object' || parentNode === null) {
                return {};
            }

            if (!Array.isArray(parentNode.nodeList)) {
                parentNode.nodeList = [];
            }

            return parentNode;
        });

        return network;
    });
};

export const inventoryView = (locationId) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(inventoryViewRequest(locationId));

        userService.inventoryView(locationId).then(
            (response) => {
                const { enterpriseName, ecpdId, nibId, networks, solutionType, ldps, updatedDate } = response.data;
                dispatch(inventoryViewSuccess({ enterpriseName, ecpdId, nibId, networks, solutionType, updatedDate, ldps }));
                resolve({ enterpriseName, ecpdId, nibId, networks, solutionType, updatedDate, ldps });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(inventoryViewApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const renewView = () => (dispatch) =>
    new Promise((resolve, reject) => {
        userService.renewView().then(
            (response) => {
                resolve();
            },
            (error) => {
                const { message, form = {} } = error.data;
                return reject({ message, form });
            }
        );
    });
export const downloadInventoryCsv = (progressCallback, setupCancelerCallback, locationId) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(downloadInventoryRequest());

        userService.downloadInventory(progressCallback, setupCancelerCallback, locationId).then(
            (response) => {
                const blob = response.data;

                dispatch(downloadInventorySuccess());

                resolve({ blob, canceled: false });
            },
            ({ error, canceled }) => {
                if (canceled === true) {
                    return resolve({ canceled: true });
                }

                const { response = {} } = error;
                const { message, form = {} } = response.data;

                dispatch(downloadInventoryApiError(message, form));

                return reject({ message, form });
            }
        );
    });

export const offlineNodes = (locationId) => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(offlineNodesRequest(locationId));

        userService.offlineNodes(locationId).then(
            (response) => {
                const { status } = response;
                const { offlineNodesCount, offlineNodeList = [] } = response.data;
                const data = offlineNodeList;
                // dispatch(offlineNodesSuccess(data));
                resolve({ offlineNodesCount, offlineNodeList });
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(offlineNodeApiError(message, form));
                return reject({ message, form });
            }
        );
    });

export const getGISConfig = (locationId) => (dispatch) =>
    new Promise((resolve, reject) => {
        userServices.getGISConfig(locationId).then(
            (response) => {
                resolve(response.data);
            },
            (error) => {
                const { message, form = {} } = error.data;
                return reject({ message, form });
            }
        );
    });

export const getMapAvailability = () => (dispatch) =>
    new Promise((resolve, reject) => {
        userServices.getMapAvailability().then(
            (response) => {
                resolve(response.data);
            },
            (error) => {
                const { message, form = {} } = error.data;
                return reject({ message, form });
            }
        );
    });

export const inBuildingView = () => (dispatch) =>
    new Promise((resolve, reject) => {
        dispatch(inBuildingViewRequest());

        userService.inBuildingView().then(
            (response) => {
                dispatch(inBuildingViewSuccess(response.data));
                resolve(response.data);
            },
            (error) => {
                const { message, form = {} } = error.data;
                dispatch(inBuildingViewApiError(message, form));
                return reject({ message, form });
            }
        );
    });
